import { render } from "./delaervat_form.vue?vue&type=template&id=47939c2b&scoped=true"
import script from "./delaervat_form.vue?vue&type=script&lang=js"
export * from "./delaervat_form.vue?vue&type=script&lang=js"

import "./delaervat_form.vue?vue&type=style&index=0&id=47939c2b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47939c2b"]])

export default __exports__